import React, { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { fetchMySpace } from '../services/api';
import Browse from './Browse';

interface NavState { folderId?: string; highlightItemId?: string }

export default function BrowseWrapper() {
  const { spaceId: paramSpaceId } = useParams<{ spaceId?: string }>();
  const location = useLocation();
  const navState = location.state as NavState | null;
  const [folderId, setFolderId] = useState<string | undefined>(() => navState?.folderId);

  // A search hit navigates here with a target folder. The initial useState only
  // runs once, so without this a second hit in the same space would be ignored.
  // location.key changes on every navigation, including to the same URL.
  useEffect(() => {
    if (navState && 'folderId' in navState) setFolderId(navState.folderId);
  }, [location.key]);

  const { data: mySpace } = useQuery({
    queryKey: ['spaces', 'me'],
    queryFn: fetchMySpace,
    enabled: !paramSpaceId,
  });

  const spaceId = paramSpaceId ?? mySpace?.id;

  if (!spaceId) {
    return (
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--ink-3)' }}>
        <span className="t-spinner" style={{ width: 28, height: 28 }} />
      </div>
    );
  }

  return (
    <Browse
      spaceId={spaceId}
      folderId={folderId}
      mode="browse"
      highlightItemId={navState?.highlightItemId}
      onNavigate={(sid, fid) => setFolderId(fid)}
    />
  );
}

export function RecentWrapper() {
  return <Browse mode="recent" />;
}

export function StarredWrapper() {
  return <Browse mode="starred" />;
}

export function SharedWrapper() {
  return <Browse mode="shared" />;
}
